export const API_URL = window.env.REACT_APP_API_URL;
export const RECAPTCHA_KEY = window.env.REACT_APP_RECAPTCHA_KEY;
